var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/home' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("系统管理")]),_c('el-breadcrumb-item',[_vm._v("用户管理")])],1),_c('el-card',[_c('p',[_vm._v("暂未开放!")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }